import faq from "./faqContent.json";
import { DEFAULT_LOCALE } from "./pageMeta";

export type SeoFaqItem = { question: string; answer: string };

type FaqLocale = { home: SeoFaqItem[]; generatorExtra: SeoFaqItem[] };

const byLocale = faq as unknown as Record<string, FaqLocale>;

function forLocale(locale: string): FaqLocale {
    return byLocale[locale] ?? byLocale[DEFAULT_LOCALE];
}

/** Shared copy for the on-page FAQ + FAQPage schema (home). */
export function getHomeFaqItems(locale: string = DEFAULT_LOCALE): SeoFaqItem[] {
    return forLocale(locale).home;
}

/** Generator and /faq pages: the home questions plus tool-specific entries. */
export function getGeneratorFaqItems(locale: string = DEFAULT_LOCALE): SeoFaqItem[] {
    const l = forLocale(locale);
    return [...l.home, ...l.generatorExtra];
}

export const homeFaqItems: SeoFaqItem[] = getHomeFaqItems();
export const generatorFaqItems: SeoFaqItem[] = getGeneratorFaqItems();

export function buildFaqPageJsonLd(items: SeoFaqItem[]): string {
    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: items.map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: {
                "@type": "Answer",
                text: item.answer,
            },
        })),
    });
}
